import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bbi-report-topbar-tag',
  templateUrl: './bbi-report-topbar-tag.component.html',
  styleUrls: ['./bbi-report-topbar-tag.component.scss']
})
export class BbiReportTopbarTagComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
